import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class AddressRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/addresses/list');
    }

    async getAll() {
        if (Cache.get('addresses')) {
            return Cache.get('addresses');
        }

        return this.setPerPage(1000).run().then((res) => {
            Cache.set('addresses', res.data);
            return Cache.get('addresses');
        });
    }
}
